import React, { useState, useEffect } from "react";
import useGetListaURL from "../../hooks/useGetListaURL.js";
import ComboSelector, { TipoClave } from "../UI/campos/ComboSelector.js";
import * as UI from "../constantes/UI.js";
import MensajeError from "../UI/MensajeError.js";

const SelectLocalidad = (props) => {
  const pais = props.pais;
  const provincia = props.provincia;
  const localidadActual = props.localidadActual;
  const incluirNulo = props.incluirNulo || false;
  const estilo = props.estilo;
  const [lista, setLista] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const setListaLocalidades = (localidades) => {
      if (incluirNulo) {
        setLista([{ id: null, nombre: UI.ITEM_COMBO_VACIO }, ...localidades]);
      } else {
        setLista(localidades);
      }
    }

    if (pais) {
      let url = "paises/" + pais.id;
      if (provincia) {
        url += "/provincias/" + provincia.id;
      }
      url += "/localidades";
      fetchData(url, setListaLocalidades);
    } else {
      setLista([]);
    }
  }, [fetchData, pais, provincia, incluirNulo]);

  const onItemElegido = (itemElegido) => {
    props.onLocalidadElegida(itemElegido);
  };

  let valorActual = "";
  if (localidadActual) {
    if (localidadActual.nombre) {
      valorActual = localidadActual.nombre;
    } else if (lista.length > 0) {
      for (let i=0; i < lista.length; i++) {
        if (Number(lista[i].id) === Number(localidadActual.id)) {
          valorActual = lista[i].nombre;
          break;
        }
      }
    }
  }

  return (
    <React.Fragment>
      <ComboSelector
        estilo={estilo}
        lista={lista}
        valorActual={valorActual}
        campoClave={TipoClave.ID}
        campoDescripcion="nombre"
        isCargando={isCargando}
        onItemElegido={onItemElegido}
      />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectLocalidad;
